import { initReactI18next } from 'react-i18next';
import { createInstance } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getLanguageFromStorage } from 'syf-js-utilities';
import englishTranslations from './lang/en';
import spanishTranslations from './lang/es';
var translations = {
    en: englishTranslations,
    es: spanishTranslations
};
var rewardsI18n = createInstance({
    fallbackLng: 'en',
    lng: getLanguageFromStorage(),
    interpolation: {
        escapeValue: false // not needed for react as it escapes by default
    },
    resources: translations,
    parseMissingKeyHandler: function () { return ''; }
});
rewardsI18n.use(LanguageDetector).use(initReactI18next).init();
export default rewardsI18n;
